module.exports = __webpack_public_path__ + "img/car_0005.2caa14d3.jpg";